import React from "react";

import { useLocation, useParams } from "react-router";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

import { useQuery } from "@apollo/client";

// import moment from "moment";

// import addvantageMessages from '../translations/addvantage/messages';

import collections from "./collections";
import tabs from "./tabs";

import StationInfo from "./station-info";

import CableCarPanel from "./panels/cable-car-panel";
import CropOverviewPanelContainer from "./panels/crop-overview-panel-container";
import ExternalUrlPanel from "./panels/external-url-panel";
import OverviewPanel from "./panels/overview-panel";
import SimplePanel from "./panels/simple-panel";
import SoilmoisturePanelContainer from "./panels/soilmoisture-panel-container";
import SoilmoistureOverviewPanelContainer from "./panels/soilmoisture-overview-panel-container";
import TrendOverviewPanel from "./panels/trend-overview-panel";
import WindrosePanel from "./panels/windrose-panel";

import { tabVar } from "../../reactive-variables";
import { useReactiveQueryParam } from "../../use-reactive-query-params";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // margin: theme.spacing(1),
      marginBottom: theme.spacing(1),
      padding: theme.spacing(1),
    },
  })
);

interface Props {}

function LiveDataPanelContainer(props: Props) {
  const classes = useStyles(props);
  // const { intl /*, logo, logoText, routes*/ } = props;

  const { panelCollectionName = "weather" } = useParams<any>();
  const searchParams = new URLSearchParams(useLocation().search);
  const nodeParam = searchParams.get("node"); // TODO useQueryParam?
  const tabReactiveVar = useReactiveQueryParam("tab", tabVar);

  // const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    // setActiveTab(newValue);
    tabReactiveVar(tabsData.tabs[newValue].id);
  };

  const { data: tabsData, error: tabsError, loading: tabsLoading } = useQuery(
    tabs,
    {
      variables: { name: panelCollectionName, node: nodeParam },
    }
  );
  const {
    data: collectionsData,
    error: collectionsError,
    loading: collectionsLoading,
  } = useQuery(collections);
  if (tabsLoading) {
    return <div>Loading...</div>;
  }
  if (tabsError) {
    console.error(tabsError);
    return <p>Error :(</p>;
  }
  // console.log("tabs", tabsData);
  if (collectionsLoading) {
    return <div>Loading...</div>;
  }
  if (collectionsError) {
    console.error(collectionsError);
    return <p>Error :(</p>;
  }
  // console.log("collections", collectionsData, panelCollectionName);
  const panelCollection = collectionsData.collections.find(
    (pc: any) => pc.name === panelCollectionName
  );

  let activeTab = tabsData.tabs.findIndex(
    (tab: any) => tab.id === tabReactiveVar()
  );
  activeTab = Math.max(0, activeTab);
  // TODO consider creating Routes!
  const tab = tabsData.tabs[activeTab];
  const panelComponentName = tab.uri.substring(
    tab.uri.lastIndexOf("/") + 1,
    tab.uri.length - 4
  );
  const panelDefinition = panelCollection.panelDefinition.find(
    (pd: any) => pd.id === tab.id
  );
  // const panelName = panelDefinition?.template;

  // console.log("selected panel from tab is", panelComponentName, panelName);

  // FIXME handle "tab" explicitly in requests (esp. for externalURLPanel)

  return (
    <Container>
      <Paper className={classes.root}>
        <StationInfo
          nodes={[nodeParam]}
          panelCollectionName={panelCollectionName}
          panelDefinition={panelDefinition}
        />
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabsData.tabs.map((tab: any) => (
            <Tab key={tab.id} label={tab.name} />
          ))}
        </Tabs>
        {panelComponentName === "overview" && (
          <OverviewPanel
            nodes={[nodeParam]}
            panelCollectionName={panelCollectionName}
            panelDefinition={panelDefinition}
          />
        )}
        {panelComponentName === "simplePanel" && (
          <SimplePanel
            nodes={[nodeParam]}
            panelCollectionName={panelCollectionName}
            panelDefinition={panelDefinition}
          />
        )}

        {panelComponentName === "cablecar_overview" && (
          <CableCarPanel
            nodes={[nodeParam]}
            panelCollectionName={panelCollectionName}
            panelDefinition={panelDefinition}
          />
        )}
        {panelComponentName === "crop_overview" && (
          <CropOverviewPanelContainer
            nodes={[nodeParam]}
            panelCollectionName={panelCollectionName}
            panelDefinition={panelDefinition}
          />
        )}
        {panelComponentName === "externalURLPanel" && (
          <ExternalUrlPanel
            nodes={[nodeParam]}
            panelCollectionName={panelCollectionName}
            panelDefinition={panelDefinition}
            title="" // TODO
            externalUrl={tab.externalUrl} // TODO
          />
        )}
        {panelComponentName === "soilmoisture_overview" && (
          <SoilmoistureOverviewPanelContainer
            nodes={[nodeParam]}
            panelCollectionName={panelCollectionName}
            panelDefinition={panelDefinition}
          />
        )}
        {panelComponentName === "soilmoisturePanel" && (
          <SoilmoisturePanelContainer
            nodes={[nodeParam]}
            panelCollectionName={panelCollectionName}
            panelDefinition={panelDefinition}
          />
        )}
        {panelComponentName === "trend_overview" && (
          <TrendOverviewPanel
            nodes={[nodeParam]}
            panelCollectionName={panelCollectionName}
            panelDefinition={panelDefinition}
          />
        )}
        {panelComponentName === "windrosePanel" && (
          <WindrosePanel
            nodes={[nodeParam]}
            panelCollectionName={panelCollectionName}
            panelDefinition={panelDefinition}
          />
        )}
      </Paper>
    </Container>
  );
}

export default LiveDataPanelContainer;
